package com.nonopn.skywatcher.app.utils

inline fun <T> takeIf(condition: Boolean, calculation: () -> T) = if (condition) {
    calculation()
} else {
    null
}
